// extracted by mini-css-extract-plugin
module.exports = {"md":"gift-button-add_md_3_MFg","ios":"gift-button-add_ios_12V7R","button":"gift-button-add_button_2EXyG","coupon":"gift-button-add_coupon_3kto0"};